module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./office-haikus.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/office-haikus.md
// module id = 27
// module chunks = 4